import { subscribe } from '@wh/message-bus';
import { isEntryOmitted, parsePiHeaderSlotItem, openLink } from '../../utils';

export const subNavStartPlugin = {
  beforeRender({ header, params, content, deviceType, locale }) {
    if (!header.subNavStart) {
      header.subNavStart = {
        type: '@sitebase/sub-nav-start',
        data: {
          id: 'kraken-sub-nav-start',
        },
        children: [],
      };
    }

    if (process.env.RUNTIME === 'browser') {
      subscribe('wh.common.event.ui.header.sub-menu-start.requested', (_topic, data) => {
        openLink(data.link);
      });
    }

    const isOmitted = isEntryOmitted(deviceType, locale);

    params.items
      .map((x) => parsePiHeaderSlotItem(x, { isOmitted, content }))
      .filter((x) => x)
      .forEach((x) => header.subNavStart.children.push(x));
  },
};
